module.exports = __webpack_public_path__ + "img/complete.f60f0091.png";